import { styled } from '@mui/material/styles';

export const GraphicsContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  width: '100%',
  gap: 16,
});

export const GraphicsStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 16,
  width: 480,
  height: 312,
  backgroundColor: '#171D2D',
  marginBottom: 42,
  borderRadius: 16,
  '& h4': {
    textAlign: 'center',
    marginTop: 16,
    marginBottom: 32,
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
  },
  '& > p': {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.global.white,
    paddingLeft: 32,
  },
  '& hr': {
    backgroundColor: '#2B3550',
    border: 'none',
    height: 1,
  },
  '@media (min-width: 1024px)': {
    width: 480,
    '& p': {
      fontSize: 14,
      marginTop: 16,
    },
  },
  '@media (min-width: 1920px)': {
    width: '49rem',
    height: 365,
    '& p': {
      fontSize: '1rem',
      marginTop: 32,
    },
    '& h4': {
      fontSize: '1.25rem',
    },
  },
}));

export const UsersProfileStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: '#fff',
  margin: 12,
  '& .link': {
    color: '#1F5F9F',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.5,
    },
  },
  '& p': {
    fontFamily: theme.typography.body2.fontFamily,
    '@media (min-width: 1024px)': {
      fontSize: 13,
      fontWeight: theme.typography.h6.fontWeight,
      marginTop: 0,
    },
    '@media (min-width: 1920px)': {
      fontSize: 15,
      padding: '0 16px',
    },
  },
}));
